@if (!isAuthenticated) {
  <app-portal-navbar></app-portal-navbar>
}

<ion-content [fullscreen]="!isAuthenticated" [scrollEvents]="true">

  <!-- HERO -->
  <div class="hero" [class.hero--public]="!isAuthenticated" [class.hero--shell]="isAuthenticated">
    <div class="hero-grid-overlay"></div>
    <p class="eyebrow">{{ 'developer.heroEyebrow' | translate }}</p>
    <h1>{{ 'developer.heroTitleLine1' | translate }}<br><span class="gradient-text">{{ 'developer.heroTitleLine2' | translate }}</span></h1>
    <p class="hero-sub">{{ 'developer.heroSub' | translate }}</p>
    <a class="btn-hero" [href]="developerPortalUrl" target="_blank" rel="noopener">
      {{ 'developer.ctaButton' | translate }}
      <ion-icon name="open-outline"></ion-icon>
    </a>
  </div>

  <!-- ENDPOINTS -->
  <div class="developer-wrapper">
    <p class="section-eyebrow">{{ 'developer.endpointsEyebrow' | translate }}</p>
    <h2 class="section-title">{{ 'developer.endpointsTitle' | translate }}</h2>

    <div class="endpoints-list">
      @for (e of endpoints; track e) {
        <div class="endpoint-row">
          <div class="endpoint-row__methods">
            @for (m of e.methods; track m) {
              <span class="method-badge" [class.method-badge--write]="m !== 'GET'">{{ m }}</span>
            }
          </div>
          <div class="endpoint-row__body">
            <div class="endpoint-row__top">
              <h3>{{ e.titleKey | translate }}</h3>
              <code class="endpoint-row__path">{{ e.path }}</code>
            </div>
            <p>{{ e.descKey | translate }}</p>
          </div>
          <span class="endpoint-row__scope">{{ e.scope }}</span>
        </div>
      }
    </div>
  </div>

  <!-- AUTH -->
  <div class="auth-section">
    <div class="auth-inner">
      <div class="auth-copy">
        <p class="section-eyebrow">{{ 'developer.authEyebrow' | translate }}</p>
        <h2 class="section-title">{{ 'developer.authTitle' | translate }}</h2>
        <p class="auth-desc">{{ 'developer.authDesc' | translate }}</p>
        <div class="auth-points">
          <div class="auth-point">
            <span class="auth-point__badge"><ion-icon name="key-outline"></ion-icon></span>
            <span>{{ 'developer.authPoint1' | translate }}</span>
          </div>
          <div class="auth-point">
            <span class="auth-point__badge"><ion-icon name="shield-checkmark-outline"></ion-icon></span>
            <span>{{ 'developer.authPoint2' | translate }}</span>
          </div>
          <div class="auth-point">
            <span class="auth-point__badge"><ion-icon name="speedometer-outline"></ion-icon></span>
            <span>{{ 'developer.authPoint3' | translate }}</span>
          </div>
        </div>
      </div>
      <div class="auth-code">
        <div class="auth-code__bar">
          <span class="auth-code__dot"></span><span class="auth-code__dot"></span><span class="auth-code__dot"></span>
          <span class="auth-code__label">Terminal</span>
        </div>
        <pre class="auth-code__request"><code><span class="tok-cmd">curl</span> {{ apiBaseUrl }}/company \<br>&nbsp;&nbsp;-H <span class="tok-str">"Authorization: Bearer gmpat_••••••••••••••••••••••••••••••"</span></code></pre>
        <pre class="auth-code__response"><code>{{ '{' }}<br>&nbsp;&nbsp;<span class="tok-key">"name"</span>: <span class="tok-str">"Ristorante Bellavista"</span>,<br>&nbsp;&nbsp;<span class="tok-key">"contactEmail"</span>: <span class="tok-str">"info&#64;bellavista.ch"</span>,<br>&nbsp;&nbsp;<span class="tok-key">"website"</span>: <span class="tok-str">"https://bellavista.ch"</span><br>{{ '}' }}</code></pre>
      </div>
    </div>
  </div>

  <!-- CTA BANNER -->
  <div class="integration-banner">
    <span class="banner-icon"><ion-icon name="code-slash-outline"></ion-icon></span>
    <div>
      <h3>{{ 'developer.ctaTitle' | translate }}</h3>
      <p>{{ 'developer.ctaDesc' | translate }}</p>
    </div>
    <ion-button shape="round" fill="outline" class="btn-banner" [href]="developerPortalUrl" target="_blank" rel="noopener">
      {{ 'developer.ctaButton' | translate }}
      <ion-icon name="open-outline" slot="end"></ion-icon>
    </ion-button>
  </div>

  <app-portal-footer></app-portal-footer>

</ion-content>
